/**
 * Application route constants.
 *
 * Use these when constructing paths in components, hooks, or tests to avoid
 * silent breakage from inline string literals drifting out of sync.
 *
 * Dynamic segments (e.g. edit/:id) are expressed as builder functions so
 * callers never have to perform their own string interpolation.
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  TRIPS: '/trips',
  TRIPS_NEW: '/trips/new',
  tripEdit: (id: string | number) => `/trips/edit/${id}`,
  tripItinerary: (id: string | number) => `/trips/${id}/itinerary`,
  sharedTrip: (shareToken: string) => `/s/${shareToken}`,
} as const;
